import React from 'react';
import styles from './ServicesPreview.module.css';
import Button from '../../common/Button/Button';
import ServiceCard from '../../services/ServiceCard/ServiceCard'; // Importer la nouvelle carte

const services = [
  {
    title: "Maisons Ossature Bois",
    description: "Construisez la maison de vos rêves, saine, performante et respectueuse de l'environnement.",
    imageSrc: "/images/maison.jpg",
  },
  {
    title: "Extensions & Surélévations",
    description: "Agrandissez votre espace de vie avec des solutions bois harmonieuses et rapides à mettre en œuvre.",
    imageSrc: "/images/extension1.jpg",
  },
  {
    title: "Aménagements Extérieurs",
    description: "Terrasses, pergolas, carports... sublimez votre jardin avec des créations bois sur mesure.",
    imageSrc: "/images/terrasse1.jpg",
  },
  {
    title: "Bâtiments Professionnels",
    description: "Des locaux commerciaux et tertiaires chaleureux, construits rapidement pour votre entreprise.",
    imageSrc: "/images/maison2.jpg",
  },
  {
    title: "Bâtiments Agricoles",
    description: "Structures en bois robustes, durables et naturellement adaptées aux besoins du monde agricole.",
    imageSrc: "/images/maison3.jpg",
  },
  {
    title: "Bureau d'Étude & Conception",
    description: "Modélisation 3D et dessins de plans, de l'esquisse initiale jusqu'à l'exécution du chantier.",
    imageSrc: "/images/plan_service.jpg",
  }
];

function ServicesPreview() {
  return (
    <section className={styles.servicesPreview}>
      <div className="container">
        <div className={styles.servicesContent}>
          <span className={styles.eyebrow}>Notre Savoir-Faire</span>
          <h2 className={styles.title}>Nos Prestations Clés</h2>
          <div className={styles.divider}></div>
          <p className={styles.description}>Découvrez comment nous pouvons concrétiser votre projet bois avec expertise et passion.</p>

          <div className={styles.servicesGrid}>
            {services.map((service, index) => (
              <ServiceCard
                key={index}
                title={service.title}
                description={service.description}
                imageSrc={service.imageSrc}
              />
            ))}
          </div>

          <div className={styles.buttonContainer}>
            <Button to="/services" variant="primary">Voir toutes nos prestations</Button>
          </div>
        </div>
      </div>
    </section>

  );
}

export default ServicesPreview;
